"use client";

import Link from "next/link";
import { ArrowLeft, Headset, Mail, Phone } from "lucide-react";
import { AuthHeading, AuthLayout } from "@/components/auth-ui";
import { supportContacts } from "@/lib/support-contacts";

/* Contact support (UX Revision 2f): just the ways to reach a person. */

const channels = [
  { href: `mailto:${supportContacts.email}`, icon: Mail, value: supportContacts.email, detail: "Facility360 accounts, registration and sign-in" },
  { href: `mailto:${supportContacts.helpdeskEmail}`, icon: Headset, value: supportContacts.helpdeskEmail, detail: "Digital Health Agency helpdesk · general inquiries" },
  { href: `tel:${supportContacts.phone}`, icon: Phone, value: `Call ${supportContacts.phone}`, detail: `${supportContacts.hours} · 24/7 for critical system issues` },
];

export default function ContactPage() {
  return <AuthLayout variant="sign-in">
    <AuthHeading overline="Support" title="Contact us">Email or call us and we’ll help with your account or facility registration.</AuthHeading>
    <section className="auth-next-steps" aria-labelledby="contact-channels-title">
      <h2 id="contact-channels-title" className="auth-next-steps-title">Reach support</h2>
      <ul className="auth-next-steps-list">
        {channels.map(({ href, icon: Icon, value, detail }) => <li key={href}><a className="auth-next-step" href={href}><span className="auth-next-step-tile" aria-hidden="true"><Icon size={18} /></span><span><strong>{value}</strong>{detail}</span></a></li>)}
      </ul>
    </section>
    <p className="auth-switch"><Link href="/sign-in"><ArrowLeft size={14} aria-hidden="true" /> Back to sign in</Link></p>
  </AuthLayout>;
}
